import { getCurrentInstance } from "vue";
const useCurrentComponentId = () => {
  const instance = getCurrentInstance();
  if (!instance.appContext.app) {
    return String(instance.uid);
  }
  return `${instance.appContext.app._uid}_${instance.uid}`;
};
export {
  useCurrentComponentId as u
};
//# sourceMappingURL=useCurrentComponentId.js.map
